import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { rootPath, userCreatorStagePath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { UserCreatorDateOfBirthStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  date_of_birth: string | null;
}

type FormData = {
  date_of_birth: string;
};

const UserCreatorDateOfBirthStep = ({ stage_index, stage_order, date_of_birth }: PageProps) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => userCreatorStagePath(stage),
        entryUrl: rootPath(),
      },
      stageName: "date_of_birth",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { date_of_birth: date_of_birth ?? "" },
    });

  const topBarActions = useCreatorTopBarActions();

  return (
    <>
      <Head title={t("web.user.creator.date_of_birth.show.meta_title")}>
        <meta name="description" content={t("web.user.creator.date_of_birth.show.meta_description")} />
      </Head>
      <UserCreatorDateOfBirthStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={form.data.date_of_birth}
        error={fieldError("date_of_birth")}
        onChange={(next) => form.setData("date_of_birth", next)}
        onBlur={() => validate("date_of_birth")}
      />
    </>
  );
};

export default UserCreatorDateOfBirthStep;
